import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { ServiceRow, ServiceDetail } from '../types/service';

/**
 * #621 — 실 BE 계약: 두 엔드포인트 둘 다 페이징 없는 plain 응답이다.
 *   GET /services      → GatewayServiceResponse[]
 *   GET /services/{id} → GatewayServiceDetailResponse (미존재 404 GATEWAY-404-003)
 * CRUD(create/replace/patch/delete/health-check trigger) 엔드포인트는 BE 에 존재하지 않는다.
 */
export const servicesApi = {
  list: async (): Promise<ServiceRow[]> => {
    const response = await gatewayApiClient.get<ServiceRow[]>('/services');
    return response.data;
  },

  get: async (id: string): Promise<ServiceDetail> => {
    const response = await gatewayApiClient.get<ServiceDetail>(`/services/${id}`);
    return response.data;
  },
};
